import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteProperty } from "../api/deleteProperty";

export const useDeleteProperty = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ endPoint, id, body }) => deleteProperty(endPoint, id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["allProperty"] });
    },
  });
};

